function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const button = event.currentTarget;
    if (button.classList.contains('disabled')) return;

    const previousValue = this.input.value;

    button.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      const minusDisabled = value <= min;
      buttonMinus.classList.toggle('disabled', minusDisabled);
      buttonMinus.toggleAttribute('disabled', minusDisabled);
      buttonMinus.setAttribute('aria-disabled', minusDisabled ? 'true' : 'false');
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      const plusDisabled = value >= max;
      buttonPlus.classList.toggle('disabled', plusDisabled);
      buttonPlus.toggleAttribute('disabled', plusDisabled);
      buttonPlus.setAttribute('aria-disabled', plusDisabled ? 'true' : 'false');
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const isMobileAccordion =
      window.matchMedia('(max-width: 1170px)').matches &&
      !!summaryElement.closest('.mp-header-drawer--mobile-accordion') &&
      detailsElement !== this.mainDetailsToggle &&
      detailsElement.classList.contains('mp-drawer-accordion');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 1170px)').matches) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      if (isMobileAccordion) {
        // Allow native <details> toggling for accordion panels inside the mobile drawer.
        window.setTimeout(() => {
          summaryElement.setAttribute('aria-expanded', detailsElement.hasAttribute('open'));
        }, 0);
        return;
      }
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

(() => {
  const OPEN_CLASS = 'mp-mobile-search--open';
  let lastOpener = null;

  const getEls = () => {
    const modal = document.getElementById('mp-mobile-search-modal');
    if (!modal) return null;

    return {
      modal,
      backdrop: modal.querySelector('.mp-mobile-search-modal__backdrop'),
      close: modal.querySelector('.mp-mobile-search-modal__close'),
      input: modal.querySelector('#mp-mobile-search-input'),
    };
  };

  const open = (els, opener) => {
    els.modal.hidden = false;
    lastOpener = opener || null;
    if (lastOpener) lastOpener.setAttribute('aria-expanded', 'true');
    document.body.classList.add(OPEN_CLASS);
    document.body.style.overflow = 'hidden';
    window.setTimeout(() => els.input?.focus(), 50);
  };

  const close = (els) => {
    els.modal.hidden = true;
    if (lastOpener) {
      lastOpener.setAttribute('aria-expanded', 'false');
      lastOpener.focus();
    }
    document.body.classList.remove(OPEN_CLASS);
    document.body.style.overflow = '';
  };

  document.addEventListener('click', (e) => {
    const els = getEls();
    if (!els) return;

    const opener = e.target.closest?.('.mp-mobile-search__button');
    if (opener) {
      open(els, opener);
      return;
    }

    if (e.target === els.backdrop || e.target.closest?.('.mp-mobile-search-modal__close') === els.close) {
      close(els);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const els = getEls();
    if (!els || els.modal.hidden) return;
    close(els);
  });
})();

// Mobile drawer: topbar close button
(() => {
  const closeMenuDrawer = () => {
    const details = document.getElementById('Details-menu-drawer-container');
    if (!details) return;
    details.classList.remove('menu-opening');
    details.removeAttribute('open');
    const summary = details.querySelector('summary');
    summary?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden-desktop');
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest?.('.mp-drawer-topbar__close');
    if (!btn) return;
    e.preventDefault();
    closeMenuDrawer();
  });
})();

(() => {
  const BRAND_KEYWORDS = [
    'Dior',
    'Paco Rabanne',
    'Armani',
    'Channel',
    'Carolina Herrera',
    'Hugo Boss',
    'Tom Ford',
    'Louis Vuitton',
    'Valentino',
    'Versace',
    'Ariana Grande',
    'Gucci',
    'Mancera',
    'Dolce Gabanna',
    'Prada',
    'Lancome',
    'Calvin Klein',
    'Jean Paul Gaultier',
    'Amougae',
    'Kenzo',
    'Xerjoff',
    'Givenchy',
    'Azzaro',
    'Maison Francis Kurkdjian',
    'Bottega Veneta',
    'Lacoste',
    'DKNY',
  ];

  const escapeRegex = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const brandMatchers = BRAND_KEYWORDS.map(
    (brand) => new RegExp(`\\b${escapeRegex(brand).replace(/\s+/g, '\\s+')}\\b`, 'i')
  );

  const getTargetBrandMatch = (text) => {
    const normalizedText = (text || '').trim();
    for (const matcher of brandMatchers) {
      const match = normalizedText.match(matcher);
      if (match) return match;
    }
    return null;
  };

  const makeDot = () => {
    const dot = document.createElement('span');
    dot.className = 'cart-item__brand-dot';
    dot.setAttribute('aria-hidden', 'true');
    return dot;
  };

  const applyBrandDotToElement = (el) => {
    const sourceText = (el.dataset.brandDotSource || el.textContent || '').trim();
    const match = getTargetBrandMatch(sourceText);
    const nextEl = el.nextElementSibling;
    if (nextEl && nextEl.classList.contains('cart-item__brand-dot')) {
      nextEl.remove();
    }

    if (!el.dataset.brandDotSource) {
      el.dataset.brandDotSource = sourceText;
    }

    if (!match || typeof match.index !== 'number') {
      el.textContent = sourceText;
      return;
    }

    const matchStart = match.index;
    const matchEnd = match.index + match[0].length;
    const beforeBrand = sourceText.slice(0, matchStart);
    const brand = sourceText.slice(matchStart, matchEnd);
    const afterBrand = sourceText.slice(matchEnd);

    el.replaceChildren();
    if (beforeBrand) el.append(document.createTextNode(beforeBrand));
    el.append(document.createTextNode(brand));
    el.append(makeDot());
    if (afterBrand) el.append(document.createTextNode(afterBrand));
  };

  // When the subtitle (line above the title) contains a known brand AND the
  // title anchor is empty (product titles like "01 - Zapach podobny do Dior ..."),
  // move the brand-and-rest portion from the subtitle into the title anchor so
  // it renders on its own line, matching the standard "<Brand> • <Name>" pattern.
  const promoteSubtitleBrandToName = (subtitle, nameLink) => {
    const subtitleText = (subtitle.dataset.brandDotSource || subtitle.textContent || '').trim();
    if (!subtitle.dataset.brandDotSource) subtitle.dataset.brandDotSource = subtitleText;

    const nameSourceText = (nameLink.dataset.brandDotSource || nameLink.textContent || '').trim();
    if (!nameLink.dataset.brandDotSource) nameLink.dataset.brandDotSource = nameSourceText;

    const match = getTargetBrandMatch(subtitleText);
    if (!match || typeof match.index !== 'number') return false;
    if (nameSourceText) return false;

    const matchStart = match.index;
    const matchEnd = matchStart + match[0].length;
    const beforeBrand = subtitleText.slice(0, matchStart).replace(/\s+$/, '');
    const brand = subtitleText.slice(matchStart, matchEnd);
    const afterBrand = subtitleText.slice(matchEnd).replace(/^\s+/, '');

    const HIDE_BEFORE_BRAND_PATTERNS = [/^zapach\s+podobny\s+do$/i];
    const trimmedBeforeBrand = beforeBrand.replace(/[\s\u00A0]+$/, '').replace(/^[\s\u00A0]+/, '');
    const shouldHideSubtitle =
      trimmedBeforeBrand.length === 0 ||
      HIDE_BEFORE_BRAND_PATTERNS.some((rx) => rx.test(trimmedBeforeBrand));
    subtitle.textContent = trimmedBeforeBrand;
    subtitle.hidden = shouldHideSubtitle;

    const trailingDot = nameLink.nextElementSibling;
    if (trailingDot && trailingDot.classList.contains('cart-item__brand-dot')) {
      trailingDot.remove();
    }

    nameLink.replaceChildren();
    nameLink.append(document.createTextNode(brand));
    nameLink.append(makeDot());
    if (afterBrand) nameLink.append(document.createTextNode(' ' + afterBrand));
    return true;
  };

  const applyBrandDots = (root = document) => {
    const processed = new WeakSet();

    root.querySelectorAll('.cart-item__details').forEach((details) => {
      const subtitle = details.querySelector('.cart-item__subtitle');
      const nameLink = details.querySelector('a.cart-item__name');
      if (!subtitle || !nameLink) return;

      const promoted = promoteSubtitleBrandToName(subtitle, nameLink);
      processed.add(subtitle);
      processed.add(nameLink);
      if (!promoted) {
        applyBrandDotToElement(subtitle);
        applyBrandDotToElement(nameLink);
      }
    });

    root.querySelectorAll('a.cart-item__name, .cart-item__subtitle').forEach((el) => {
      if (processed.has(el)) return;
      applyBrandDotToElement(el);
    });
  };

  window.applyBrandDots = applyBrandDots;
  const runApplyBrandDots = () => applyBrandDots();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runApplyBrandDots, { once: true });
  } else {
    runApplyBrandDots();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, runApplyBrandDots);
  }
})();

(() => {
  const STORAGE_KEY = 'mp_cart_discount_code';
  const ERROR_TEXT = 'Kod rabatowy jest nieprawidłowy lub wygasł';
  const ERROR_INAPPLICABLE = 'Ten kod jest nieprawidłowy.';

  const getShopifyRouteRoot = () => {
    try {
      return (typeof window !== 'undefined' && window.Shopify?.routes?.root) || '/';
    } catch (e) {
      return '/';
    }
  };

  const getRedirectPath = () => {
    const path = window.location.pathname + window.location.search;
    return path || '/';
  };

  const normalizeDiscountCode = (value) => String(value || '').trim().toLowerCase();

  const discountCodesList = (cart) => {
    const raw = cart?.discount_codes ?? cart?.discountCodes;
    return Array.isArray(raw) ? raw : [];
  };

  const discountCodeMatchesEntered = (dc, entered) => {
    const n = normalizeDiscountCode(entered);
    if (!n) return false;
    const c = normalizeDiscountCode(dc?.code ?? dc?.discount_code);
    return c === n;
  };

  const applicationMatchesEnteredCode = (d, entered) => {
    const n = normalizeDiscountCode(entered);
    if (!n) return false;
    const typ = String(d?.type || '').toLowerCase();
    if (typ === 'automatic') return false;
    const t = normalizeDiscountCode(d?.title);
    const desc = normalizeDiscountCode(d?.description);
    const codeField = normalizeDiscountCode(d?.code);
    return t === n || desc === n || codeField === n;
  };

  const lineItemsReflectEnteredCode = (cart, entered) => {
    const n = normalizeDiscountCode(entered);
    const items = cart?.items;
    if (!Array.isArray(items) || !n) return false;
    return items.some((line) => {
      const discounts = line?.discounts;
      if (!Array.isArray(discounts)) return false;
      return discounts.some((di) => applicationMatchesEnteredCode(di, entered) || normalizeDiscountCode(di?.title) === n);
    });
  };

  /** New cart-level `discount_code` application since `beforeCart` (covers APIs where title ≠ typed code). */
  const newDiscountApplicationSince = (beforeCart, afterCart) => {
    const b = Array.isArray(beforeCart?.cart_level_discount_applications) ? beforeCart.cart_level_discount_applications : [];
    const a = Array.isArray(afterCart?.cart_level_discount_applications) ? afterCart.cart_level_discount_applications : [];
    const sig = (app) =>
      `${String(app?.type || '')}|${String(app?.title || '')}|${String(app?.description || '')}|${String(app?.total_allocated_amount ?? '')}`;
    const bSet = new Set(b.map(sig));
    const newcomers = a.filter((app) => !bSet.has(sig(app)));
    return newcomers.some((app) => String(app?.type || '').toLowerCase() === 'discount_code');
  };

  const findDiscountCodeRow = (cart, entered) => {
    return discountCodesList(cart).find((dc) => discountCodeMatchesEntered(dc, entered));
  };

  /**
   * True when Shopify treats the code as applied (`discount_codes[].applicable`), or allocations match the input.
   * Note: Shopify still lists unknown strings under `discount_codes` with `applicable: false` — those must fail.
   */
  const codeRecognizedInCart = (cart, entered) => {
    const n = normalizeDiscountCode(entered);
    if (!n) return false;
    const list = discountCodesList(cart);
    if (list.length > 0) {
      const row = list.find((dc) => discountCodeMatchesEntered(dc, entered));
      if (row) return row.applicable === true;
    }
    const apps = cart?.cart_level_discount_applications;
    if (Array.isArray(apps) && apps.length > 0 && apps.some((d) => applicationMatchesEnteredCode(d, entered))) {
      return true;
    }
    return lineItemsReflectEnteredCode(cart, entered);
  };

  const fetchCart = async () => {
    const url = `${getShopifyRouteRoot()}cart.js`;
    const res = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('cart fetch failed');
    return await res.json();
  };

  const updateCartDiscount = async (discountValue) => {
    const url = `${getShopifyRouteRoot()}cart/update.js`;
    const tryJson = async () => {
      const res = await fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: discountValue }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        const err = new Error(data?.description || data?.message || 'cart update failed');
        err.status = res.status;
        throw err;
      }
      return data;
    };
    const tryForm = async () => {
      const body = new FormData();
      body.append('discount', discountValue);
      const res = await fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        body,
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        const err = new Error(data?.description || data?.message || 'cart update failed');
        err.status = res.status;
        throw err;
      }
      return data;
    };
    try {
      return await tryJson();
    } catch (e) {
      return await tryForm();
    }
  };

  const getCookie = (name) => {
    try {
      const m = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`));
      return m ? decodeURIComponent(m[1]) : '';
    } catch (e) {
      return '';
    }
  };

  const pingDiscountEndpoint = async (codeOrZero) => {
    const root = getShopifyRouteRoot();
    const target = `${root}discount/${encodeURIComponent(codeOrZero)}?redirect=${encodeURIComponent(getRedirectPath())}`;
    // This endpoint sets the discount cookie via Set-Cookie. We can call it via fetch
    // to avoid a full page reload while still applying the code.
    await fetch(target, {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'follow',
      headers: { Accept: 'text/html' },
    });
  };

  const publishCartUpdate = () => {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mp-discount' });
    }
  };

  const setErrorVisible = (root, visible, message) => {
    const el =
      root?.querySelector?.('[data-cart-discount-error]') || document.querySelector?.('[data-cart-discount-error]');
    if (!el) return;
    el.hidden = !visible;
    if (visible) {
      el.textContent = message || ERROR_TEXT;
    } else {
      el.textContent = ERROR_TEXT;
    }
  };

  const setAppliedUI = (root, code) => {
    const container = root?.closest?.('.cart-drawer__discount-body') || root?.querySelector?.('.cart-drawer__discount-body');
    if (!container) return;

    const form = container.querySelector?.('[data-cart-discount-form]');
    let applied = container.querySelector?.('.cart-drawer__discount-applied');

    const normalized = String(code || '').trim();
    const effectiveCode = normalized === '0' ? '' : normalized;
    if (!effectiveCode) {
      if (applied) applied.remove();
      if (form) form.hidden = false;
      return;
    }

    if (form) form.hidden = true;

    if (!applied) {
      applied = document.createElement('div');
      applied.className = 'cart-drawer__discount-applied';
      applied.setAttribute('role', 'status');
      applied.setAttribute('aria-live', 'polite');
      applied.innerHTML = `
        <span class="cart-drawer__discount-applied-left">
          <span class="cart-drawer__discount-check" aria-hidden="true">
            <svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false">
              <path d="M6.2 11.2 2.8 7.8l1.1-1.1 2.3 2.3 5-5 1.1 1.1-6.1 6.1Z" fill="currentColor"></path>
            </svg>
          </span>
          <span class="cart-drawer__discount-applied-text">Zastosowano kod rabatowy</span>
        </span>
        <button
          type="button"
          class="cart-drawer__discount-pill"
          data-cart-discount-remove
          aria-label="Usuń kod rabatowy"
        >
          <span class="cart-drawer__discount-pill-code"></span>
          <span class="cart-drawer__discount-pill-x" aria-hidden="true">
            <svg viewBox="0 0 16 16" focusable="false" aria-hidden="true">
              <path
                d="M12.53 3.47a.75.75 0 0 0-1.06 0L8 6.94 4.53 3.47a.75.75 0 1 0-1.06 1.06L6.94 8l-3.47 3.47a.75.75 0 1 0 1.06 1.06L8 9.06l3.47 3.47a.75.75 0 0 0 1.06-1.06L9.06 8l3.47-3.47a.75.75 0 0 0 0-1.06Z"
                fill="currentColor"
              />
            </svg>
          </span>
        </button>
      `;
      container.appendChild(applied);
    }

    const codeEl = applied.querySelector?.('.cart-drawer__discount-pill-code');
    if (codeEl) codeEl.textContent = effectiveCode;
  };

  const stripInvalidDiscount = async () => {
    try {
      await pingDiscountEndpoint('0');
    } catch (e) {
      // ignore
    }
  };

  const applyDiscount = async (code, root = document) => {
    const normalized = (code || '').trim();
    if (!normalized) return;

    let cartBefore = null;
    try {
      cartBefore = await fetchCart();
    } catch (e) {
      // ignore
    }

    let cartAfterUpdate = null;
    try {
      cartAfterUpdate = await updateCartDiscount(normalized);
    } catch (e) {
      try {
        await pingDiscountEndpoint(normalized);
        cartAfterUpdate = await fetchCart();
      } catch (e2) {
        setErrorVisible(root, true);
        publishCartUpdate();
        return;
      }
    }

    let fresh = cartAfterUpdate;
    try {
      fresh = await fetchCart();
    } catch (e) {
      // use cart payload from update if refetch fails
    }

    try {
      let applied = codeRecognizedInCart(fresh, normalized);
      if (!applied && cartBefore) {
        applied = newDiscountApplicationSince(cartBefore, fresh);
      }
      if (applied) {
        try {
          sessionStorage.setItem(STORAGE_KEY, normalized);
        } catch (e) {
          // ignore
        }
        setErrorVisible(root, false);
        setAppliedUI(root, normalized);
      } else {
        const row = findDiscountCodeRow(fresh, normalized);
        const errMsg = row && row.applicable === false ? ERROR_INAPPLICABLE : ERROR_TEXT;
        await stripInvalidDiscount();
        try {
          sessionStorage.removeItem(STORAGE_KEY);
        } catch (e) {
          // ignore
        }
        setErrorVisible(root, true, errMsg);
        setAppliedUI(root, '');
      }
    } catch (e) {
      setErrorVisible(root, false);
      setAppliedUI(root, '');
    }

    publishCartUpdate();
  };

  const clearDiscount = async (root = document) => {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      // ignore
    }
    try {
      await updateCartDiscount('');
    } catch (e) {
      // ignore
    }
    try {
      await pingDiscountEndpoint('0');
    } catch (e) {
      // ignore
    }
    setErrorVisible(root, false);
    setAppliedUI(root, '');
    publishCartUpdate();
  };

  const initDiscountForms = (root = document) => {
    root.querySelectorAll('[data-cart-discount-form]').forEach((form) => {
      if (form.dataset.mpBound === '1') return;
      form.dataset.mpBound = '1';

      const input = form.querySelector('input[name="discount"]');
      if (!form.parentElement?.querySelector?.('[data-cart-discount-error]')) {
        const error = document.createElement('div');
        error.className = 'cart-drawer__discount-error';
        error.hidden = true;
        error.setAttribute('data-cart-discount-error', '');
        form.insertAdjacentElement('afterend', error);
      }
      if (input) {
        try {
          const saved = sessionStorage.getItem(STORAGE_KEY);
          if (saved && !input.value) input.value = saved;
        } catch (e) {
          // ignore
        }
      }
      const cookieCode = (getCookie('discount_code') || '').trim();
      if (cookieCode && cookieCode !== '0') {
        fetchCart()
          .then((cart) => {
            if (codeRecognizedInCart(cart, cookieCode)) setAppliedUI(form, cookieCode);
          })
          .catch(() => {});
      }

      form.addEventListener('submit', (e) => {
        e.preventDefault();
        setErrorVisible(form, false);
        applyDiscount(input?.value, form);
      });
    });

    root.querySelectorAll('[data-cart-discount-remove]').forEach((btn) => {
      if (btn.dataset.mpBound === '1') return;
      btn.dataset.mpBound = '1';
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        clearDiscount(btn.closest?.('.cart-drawer__discount') || document);
      });
    });
  };

  const boot = () => initDiscountForms();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => initDiscountForms());
  }
})();

// Cart drawer: gift wrap + priority shipping — preview totals only (no cart API on toggle).
// Products are added/removed at checkout via initCheckoutAddons.
(() => {
  const parseCents = (v) => {
    const n = Number.parseInt(String(v || ''), 10);
    return Number.isFinite(n) ? n : 0;
  };

  const formatMoney = (cents, currencyCode) => {
    const c = cents / 100;
    const code = (currencyCode || 'PLN').toString().toUpperCase();
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(c);
    } catch (e) {
      return `${c.toFixed(2)} ${code}`;
    }
  };

  /** Adjust cents vs server totals: optional lines checked but not in cart (+), or in cart but unchecked (−). */
  const getPreviewExtraCents = () => {
    let sum = 0;
    document.querySelectorAll('[data-gift-wrap-checkbox], [data-priority-shipping-checkbox]').forEach((checkbox) => {
      const row = checkbox.closest('[data-gift-wrap]') || checkbox.closest('[data-priority-shipping]');
      const cents = parseCents(row?.getAttribute('data-addon-price-cents'));
      if (!cents) return;
      const inCart = checkbox.hasAttribute('data-in-cart');
      if (checkbox.checked && !inCart) sum += cents;
      else if (!checkbox.checked && inCart) sum -= cents;
    });
    return sum;
  };

  /** Same defaults as `snippets/cart-drawer.liquid` when summary attrs are missing. */
  const GFG_FALLBACK_SHIPPING_THRESHOLD_CENTS = 13900;
  const GFG_FALLBACK_SHIPPING_RATE_CENTS = 1199;

  const cartJsonUrlForMpAddons = () => {
    const base = typeof routes !== 'undefined' && routes.cart_url ? routes.cart_url : '/cart';
    return `${String(base).replace(/\/$/, '')}.js`;
  };

  /**
   * Same idea as the drawer “Szacowana suma” line, but uses live `/cart.js` for merchandise total.
   * Important on /cart: the drawer footer `data-mp-total-cents` is not section-swapped on line-item
   * changes, so it can stay stale while the cart is already over the threshold.
   */
  const computeGfgThresholdTotalCents = async () => {
    const res = await fetch(cartJsonUrlForMpAddons(), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    if (!res.ok) throw new Error('cart fetch failed');
    const cart = await res.json();
    const liveSubtotal = Number.parseInt(String(cart?.total_price ?? 0), 10) || 0;
    const itemCount = Number.parseInt(String(cart?.item_count ?? 0), 10) || 0;
    const cartEmpty = itemCount === 0;
    const root = document.querySelector('[data-mp-cart-summary]');
    const extra = getPreviewExtraCents();
    const shippingThreshold = root
      ? parseCents(root.dataset.mpShippingThresholdCents) || GFG_FALLBACK_SHIPPING_THRESHOLD_CENTS
      : GFG_FALLBACK_SHIPPING_THRESHOLD_CENTS;
    const shippingRate = root
      ? parseCents(root.dataset.mpShippingRateCents) || GFG_FALLBACK_SHIPPING_RATE_CENTS
      : GFG_FALLBACK_SHIPPING_RATE_CENTS;
    const subtotal = liveSubtotal + extra;
    const shippingEst = !cartEmpty && subtotal < shippingThreshold ? shippingRate : 0;
    return Math.max(0, subtotal + shippingEst);
  };

  const applyCartDrawerAddonSummaryPreview = () => {
    const root = document.querySelector('[data-mp-cart-summary]');
    if (root) {
      const baseOriginal = parseCents(root.dataset.mpOriginalCents);
      const baseTotal = parseCents(root.dataset.mpTotalCents);
      const currency = root.dataset.mpCurrency || 'PLN';
      const extra = getPreviewExtraCents();
      const shippingThreshold =
        parseCents(root.dataset.mpShippingThresholdCents) || GFG_FALLBACK_SHIPPING_THRESHOLD_CENTS;
      const shippingRate = parseCents(root.dataset.mpShippingRateCents) || GFG_FALLBACK_SHIPPING_RATE_CENTS;
      const cartEmpty = root.dataset.mpCartEmpty === '1';
      const subtotal = baseTotal + extra;
      const shippingEst =
        !cartEmpty && subtotal < shippingThreshold ? shippingRate : 0;
      const totalCents = Math.max(0, subtotal + shippingEst);
      const origEl = root.querySelector('[data-mp-summary-original]');
      const shippingEl = root.querySelector('[data-mp-summary-shipping]');
      const totalEl = root.querySelector('[data-mp-summary-total]');
      if (origEl) origEl.textContent = formatMoney(Math.max(0, baseOriginal + extra), currency);
      if (shippingEl) shippingEl.textContent = formatMoney(shippingEst, currency);
      if (totalEl) totalEl.textContent = formatMoney(totalCents, currency);
    }
  };

  const bindCartDrawerAddonCheckboxes = () => {
    document.querySelectorAll('[data-gift-wrap-checkbox], [data-priority-shipping-checkbox]').forEach((checkbox) => {
      if (checkbox.dataset.mpAddonBound === '1') return;
      checkbox.dataset.mpAddonBound = '1';

      checkbox.addEventListener('click', (e) => e.stopPropagation());

      checkbox.addEventListener('change', (e) => {
        e.stopPropagation();
        applyCartDrawerAddonSummaryPreview();
      });
    });
  };

  const boot = () => {
    bindCartDrawerAddonCheckboxes();
    applyCartDrawerAddonSummaryPreview();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => boot());
  }
})();

(() => {
  const initCheckoutAddons = (root = document) => {
    const checkoutBtn = root.getElementById?.('CartDrawer-Checkout') || root.querySelector?.('#CartDrawer-Checkout');
    if (!checkoutBtn) return;
    if (checkoutBtn.dataset.mpCheckoutAddonsBound === '1') return;
    checkoutBtn.dataset.mpCheckoutAddonsBound = '1';

    const cartJsonUrl = () => {
      const base = typeof routes !== 'undefined' && routes.cart_url ? routes.cart_url : '/cart';
      return `${base.replace(/\/$/, '')}.js`;
    };

    const changeUrl = () => (typeof routes !== 'undefined' && routes.cart_change_url ? routes.cart_change_url : '/cart/change.js');

    const fetchCartJson = async () => {
      const res = await fetch(cartJsonUrl(), { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      if (!res.ok) throw new Error('cart fetch failed');
      return await res.json();
    };

    checkoutBtn.addEventListener(
      'click',
      async (e) => {
        const addons = [];

        const giftWrap = document.querySelector('[data-gift-wrap]');
        if (giftWrap) {
          addons.push({
            checkbox: giftWrap.querySelector('[data-gift-wrap-checkbox]'),
            variantId: giftWrap.getAttribute('data-gift-variant-id'),
          });
        }

        const priority = document.querySelector('[data-priority-shipping]');
        if (priority) {
          addons.push({
            checkbox: priority.querySelector('[data-priority-shipping-checkbox]'),
            variantId: priority.getAttribute('data-priority-variant-id'),
          });
        }

        // Decide synchronously: once this handler awaits, the form submit has already
        // started and the browser leaves for checkout before the add-on reaches the cart.
        const mayChange = addons.some(
          ({ checkbox, variantId }) => checkbox && variantId && (checkbox.checked || checkbox.hasAttribute('data-in-cart'))
        );
        if (!mayChange) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        let cart;
        try {
          cart = await fetchCartJson();
        } catch (err) {
          window.location.href = '/checkout';
          return;
        }

        const items = cart.items || [];

        const toAdd = addons.filter(({ checkbox, variantId }) => {
          if (!checkbox || !variantId) return false;
          if (!checkbox.checked) return false;
          return !items.some((it) => String(it.variant_id) === String(variantId));
        });

        const toRemove = addons.filter(({ checkbox, variantId }) => {
          if (!checkbox || !variantId) return false;
          if (checkbox.checked) return false;
          return items.some((it) => String(it.variant_id) === String(variantId));
        });

        if (!toAdd.length && !toRemove.length) {
          window.location.href = '/checkout';
          return;
        }

        for (const { variantId } of toRemove) {
          const item = items.find((it) => String(it.variant_id) === String(variantId));
          if (!item) continue;
          try {
            const res = await fetch(changeUrl(), {
              ...fetchConfig(),
              credentials: 'same-origin',
              body: JSON.stringify({ id: item.key, quantity: 0 }),
            });
            await res.json();
          } catch (err) {
            // continue to checkout
          }
        }

        for (const addon of toAdd) {
          try {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ items: [{ id: Number(addon.variantId), quantity: 1 }] }),
            });
            if (!res.ok) {
              // If add fails, continue to checkout anyway
            }
          } catch (err) {
            // If add fails, continue to checkout anyway
          }
        }

        window.location.href = '/checkout';
      },
      true
    );
  };

  const boot = () => initCheckoutAddons();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => initCheckoutAddons());
  }
})();

(() => {
  const initUpsellSlider = (root = document) => {
    const sliders = [];
    if (root && root.matches && root.matches('[data-upsell-slider]')) sliders.push(root);
    root.querySelectorAll('[data-upsell-slider]').forEach((el) => sliders.push(el));

    sliders.forEach((slider) => {
      if (slider.dataset.mpBound === '1') return;

      const track = slider.querySelector('[data-upsell-track]');
      const progress = slider.querySelector('[data-upsell-progress]');
      const progressContainer = slider.querySelector('.cart-drawer__product-slider-progress');

      if (!track) return;
      if (typeof window.Swiper === 'undefined') {
        // Swiper is loaded with defer; this slider might be injected earlier (e.g. product-recommendations).
        if (slider.dataset.mpSwiperRetry === '1') return;
        slider.dataset.mpSwiperRetry = '1';
        let attempt = 0;
        const tryMount = () => {
          attempt += 1;
          if (slider.dataset.mpBound === '1') return;
          if (!slider.isConnected) return;
          if (typeof window.Swiper !== 'undefined') {
            slider.dataset.mpSwiperRetry = '0';
            initUpsellSlider(slider);
            return;
          }
          if (attempt < 120) window.setTimeout(tryMount, 25);
        };
        window.setTimeout(tryMount, 25);
        return;
      }

      slider.dataset.mpBound = '1';

      const swiper = new window.Swiper(track, {
        slidesPerView: 'auto',
        spaceBetween: 12,
        freeMode: { enabled: true, sticky: false },
        watchOverflow: true,
        resistanceRatio: 0.85,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
          sensitivity: 1,
        },
        nested: true,
      });

      // Recompute when slide images finish loading (their final width/height can
      // affect total wrapper width and Swiper's maxTranslate).
      track.querySelectorAll('img').forEach((img) => {
        if (img.complete) return;
        img.addEventListener('load', () => swiper.update(), { once: true });
        img.addEventListener('error', () => swiper.update(), { once: true });
      });

      // Recompute when the cart-drawer becomes visible (drawer can be initialized
      // while its parent is translated off-screen / hidden).
      const cartDrawer = slider.closest('cart-drawer');
      if (cartDrawer && typeof MutationObserver !== 'undefined') {
        let recomputeRaf = 0;
        const obs = new MutationObserver(() => {
          if (!cartDrawer.classList.contains('active')) return;
          if (recomputeRaf) return;
          recomputeRaf = window.requestAnimationFrame(() => {
            recomputeRaf = 0;
            swiper.update();
          });
        });
        obs.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
      }

      // Defensive: extra updates after init for late layout shifts (fonts, etc).
      window.setTimeout(() => swiper.update(), 200);
      window.setTimeout(() => swiper.update(), 800);

      const updateProgress = () => {
        if (!progress || !progressContainer) return;
        const ratio = typeof swiper.progress === 'number' ? swiper.progress : 0;
        const trackWidth = progressContainer.clientWidth || 64;
        const thumbRatio =
          swiper.virtualSize > 0 && swiper.width > 0
            ? Math.min(1, swiper.width / swiper.virtualSize)
            : 1;
        const barWidth = Math.max(8, Math.round(trackWidth * thumbRatio));
        progress.style.width = `${barWidth}px`;
        const maxX = Math.max(0, trackWidth - barWidth);
        const x = maxX * Math.max(0, Math.min(1, ratio));
        progress.style.transform = `translateX(${x}px)`;
      };

      // Mirror Swiper's own CSS transition on the wrapper so the progress bar
      // animates in sync with momentum / slide transitions instead of jumping.
      if (progress) {
        progress.style.transitionProperty = 'transform';
        progress.style.transitionTimingFunction = 'ease';
        progress.style.transitionDuration = '0ms';
      }

      swiper.on('setTransition', (_s, duration) => {
        if (!progress) return;
        progress.style.transitionDuration = `${duration || 0}ms`;
      });
      swiper.on('setTranslate', updateProgress);
      swiper.on('progress', updateProgress);
      swiper.on('transitionEnd', () => {
        if (!progress) return;
        progress.style.transitionDuration = '0ms';
        updateProgress();
      });
      swiper.on('resize', updateProgress);
      window.addEventListener('resize', () => {
        swiper.update();
        updateProgress();
      });
      updateProgress();

      slider.querySelectorAll('[data-upsell-add]').forEach((btn) => {
        btn.addEventListener('click', async (e) => {
          e.preventDefault();
          e.stopPropagation();
          const variantId = btn.getAttribute('data-variant-id');
          if (!variantId) return;
          if (btn.disabled) return;

          btn.disabled = true;
          try {
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
            });
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mp-upsell' });
            }
          } catch (err) {
            // ignore
          } finally {
            btn.disabled = false;
          }
        });
      });
    });
  };

  const boot = () => {
    initUpsellSlider(document);

    // Auto-init sliders that arrive later (e.g. product-recommendations via AJAX).
    const root = document.body;
    if (!root || typeof MutationObserver === 'undefined') return;
    const obs = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes || []) {
          if (!(node instanceof Element)) continue;
          if (node.matches?.('[data-upsell-slider]') || node.querySelector?.('[data-upsell-slider]')) {
            initUpsellSlider(node);
          }
        }
      }
    });
    obs.observe(root, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => initUpsellSlider());
  }
})();

// Cart drawer: delivery estimate (business days only)
(() => {
  const DOW = ['Ndz.', 'Pon.', 'Wt.', 'Śr.', 'Czw.', 'Pt.', 'Sob.'];

  const addBusinessDays = (date, days) => {
    const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    let remaining = days;
    while (remaining > 0) {
      d.setDate(d.getDate() + 1);
      const day = d.getDay(); // 0..6
      if (day !== 0 && day !== 6) remaining -= 1; // skip weekend
    }
    return d;
  };

  const fmt = (date) => {
    const dayName = DOW[date.getDay()] || '';
    const dd = date.getDate();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    return `${dayName} (${dd}.${mm})`;
  };

  const apply = (root = document) => {
    root.querySelectorAll?.('[data-delivery-estimate]').forEach((el) => {
      if (!el.dataset.mpBaseText) el.dataset.mpBaseText = (el.textContent || '').trim();
      const base = (el.dataset.mpBaseText || '').trim();
      if (!base) return;

      const today = new Date();
      const earliest = addBusinessDays(today, 1);
      const latest = addBusinessDays(today, 2);

      el.textContent = `${base} U Ciebie: ${fmt(earliest)} – ${fmt(latest)}`;
    });
  };

  const boot = () => apply(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => apply(document));
  }
})();

// PDP: mobile product gallery progress bar (drag left/right)
(() => {
  const init = (root = document) => {
    root.querySelectorAll?.('.mp-pdp slider-component[id^="GalleryViewer-"]').forEach((viewer) => {
      if (viewer.dataset.mpGalleryBound === '1') return;
      viewer.dataset.mpGalleryBound = '1';

      const list = viewer.querySelector?.('.product__media-list');
      const bar = viewer.querySelector?.('[data-mp-gallery-progress]');
      const track = viewer.querySelector?.('.mp-pdp__gallery-progress');
      if (!list || !bar || !track) return;

      const update = () => {
        const maxScroll = Math.max(0, list.scrollWidth - list.clientWidth);
        const ratio = maxScroll > 0 ? list.scrollLeft / maxScroll : 0;
        const barWidth = bar.getBoundingClientRect().width || 64;
        const trackWidth = track.getBoundingClientRect().width || 140;
        const maxX = Math.max(0, trackWidth - barWidth);
        const x = maxX * Math.max(0, Math.min(1, ratio));
        bar.style.transform = `translateX(${x}px)`;
      };

      let raf = 0;
      const onScroll = () => {
        if (raf) return;
        raf = window.requestAnimationFrame(() => {
          raf = 0;
          update();
        });
      };

      list.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', () => update());
      update();
    });
  };

  const boot = () => init(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  if (typeof MutationObserver !== 'undefined') {
    const root = document.body;
    if (!root) return;
    const obs = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes || []) {
          if (!(node instanceof Element)) continue;
          if (node.matches?.('.mp-pdp') || node.querySelector?.('.mp-pdp')) init(node);
        }
      }
    });
    obs.observe(root, { childList: true, subtree: true });
  }
})();

// Cart drawer rewards: tier gifts are no longer auto-added to the cart.

// Judge.me: insert numeric rating span before review count text
(() => {
  const enhance = (root = document) => {
    root.querySelectorAll?.('.jdgm-prev-badge').forEach((badge) => {
      const textEl = badge.querySelector?.('.jdgm-prev-badge__text');
      if (!textEl) return;

      if (badge.closest?.('[data-mp-pdp-rating], [data-mp-pdp-jdgm-badge]')) {
        textEl.classList.add('mp-pdp__jdgm-review-count');
      }

      const avg = badge.getAttribute('data-average-rating') || badge.dataset?.averageRating || '';
      const rating = String(avg || '').trim();
      if (!rating) return;

      let ratingEl = badge.querySelector?.('.jdgm-prev-badge__rating');
      if (!ratingEl) {
        ratingEl = document.createElement('span');
        ratingEl.className = 'jdgm-prev-badge__rating';
        textEl.parentNode?.insertBefore(ratingEl, textEl);
      }
      ratingEl.textContent = rating;

      if (!badge.querySelector?.('.jdgm-prev-badge__sep')) {
        const sep = document.createElement('span');
        sep.className = 'jdgm-prev-badge__sep';
        sep.textContent = '/';
        textEl.parentNode?.insertBefore(sep, textEl);
      }
    });
  };

  const boot = () => {
    enhance(document);

    const root = document.body;
    if (!root || typeof MutationObserver === 'undefined') return;
    const obs = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes || []) {
          if (!(node instanceof Element)) continue;
          if (node.matches?.('.jdgm-prev-badge') || node.querySelector?.('.jdgm-prev-badge')) {
            enhance(node);
          }
        }
      }
    });
    obs.observe(root, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();

// Judge.me cards-carousel: on mobile, replace JM's transform-driven slider with native
// overflow-x scroll (matches the rest of the site's swipe behavior) and add a progress bar
// that reuses the .cart-drawer__product-slider-progress styles.
(() => {
  const MOBILE_MQ = '(max-width: 989px)';

  // Inject a trust/quality badges row into the Judge.me header.
  // Done separately from the cards mobile-enhancement below so it still runs
  // even if .jdgm-cards-wrapper isn't ready yet (the header renders earlier).
  const injectBadges = (widget) => {
    if (!widget || widget.dataset.mpJdgmBadgesBound === '1') return;
    const header = widget.querySelector('.jdgm-header');
    if (!header) return;
    const urls = Array.isArray(window.mpJdgmBadges) ? window.mpJdgmBadges : [];
    if (!urls.length) return;
    if (header.querySelector('.mp-jdgm-badges')) {
      widget.dataset.mpJdgmBadgesBound = '1';
      return;
    }
    const row = document.createElement('div');
    row.className = 'mp-jdgm-badges';
    row.setAttribute('aria-hidden', 'true');
    urls.forEach((src) => {
      const img = document.createElement('img');
      img.src = src;
      img.alt = '';
      img.loading = 'lazy';
      img.className = 'mp-jdgm-badges__icon';
      row.appendChild(img);
    });
    header.appendChild(row);
    widget.dataset.mpJdgmBadgesBound = '1';
  };

  const enhanceWidget = (widget) => {
    injectBadges(widget);
    if (!widget || widget.dataset.mpJdgmBound === '1') return;

    const wrapper = widget.querySelector('.jdgm-cards-wrapper');
    const container = widget.querySelector('.jdgm-videos-container');
    const content = widget.querySelector('.jdgm-content');
    if (!wrapper || !container || !content) return;

    widget.dataset.mpJdgmBound = '1';

    const progressTrack = document.createElement('div');
    progressTrack.className = 'cart-drawer__product-slider-progress mp-jdgm-progress';
    progressTrack.setAttribute('aria-hidden', 'true');
    const progressBar = document.createElement('div');
    progressBar.className = 'cart-drawer__product-slider-progress-bar';
    progressTrack.appendChild(progressBar);
    if (content.parentNode) {
      content.parentNode.insertBefore(progressTrack, content.nextSibling);
    }

    const mql = window.matchMedia(MOBILE_MQ);

    const updateProgress = () => {
      const trackWidth = progressTrack.clientWidth || 64;
      const scrollable = wrapper.scrollWidth > wrapper.clientWidth;
      const thumbRatio = scrollable ? wrapper.clientWidth / wrapper.scrollWidth : 1;
      const barWidth = Math.max(8, Math.round(trackWidth * thumbRatio));
      progressBar.style.width = `${barWidth}px`;
      const maxX = Math.max(0, trackWidth - barWidth);
      const max = wrapper.scrollWidth - wrapper.clientWidth;
      const ratio = max > 0 ? Math.max(0, Math.min(1, wrapper.scrollLeft / max)) : 0;
      progressBar.style.transform = `translateX(${maxX * ratio}px)`;
    };

    // iOS Safari + Judge.me: JM attaches touch handlers that can prevent native horizontal scrolling.
    // In mobile mode we force a simple "drag to scrollLeft" behavior and stop other touchmove
    // handlers from swallowing the gesture.
    const bindTouchDrag = () => {
      if (wrapper.dataset.mpTouchDragBound === '1') return;
      wrapper.dataset.mpTouchDragBound = '1';

      let isDown = false;
      let startX = 0;
      let startScrollLeft = 0;
      let prevSnapType = '';
      let raf = 0;
      let pendingScrollLeft = null;

      const onTouchStart = (e) => {
        if (!widget.classList.contains('mp-jdgm-mobile')) return;
        const t = e.touches && e.touches[0];
        if (!t) return;
        e.preventDefault();
        isDown = true;
        startX = t.clientX;
        startScrollLeft = wrapper.scrollLeft;
        prevSnapType = wrapper.style.scrollSnapType || '';
        // Disable snapping while dragging to avoid "jumping" on iOS.
        wrapper.style.scrollSnapType = 'none';
        e.stopImmediatePropagation();
      };

      const onTouchMove = (e) => {
        if (!isDown) return;
        if (!widget.classList.contains('mp-jdgm-mobile')) return;
        const t = e.touches && e.touches[0];
        if (!t) return;
        const dx = t.clientX - startX;
        pendingScrollLeft = startScrollLeft - dx;
        if (!raf) {
          raf = window.requestAnimationFrame(() => {
            raf = 0;
            if (pendingScrollLeft == null) return;
            wrapper.scrollLeft = pendingScrollLeft;
            pendingScrollLeft = null;
            updateProgress();
          });
        }
        e.preventDefault();
        e.stopImmediatePropagation();
      };

      const onTouchEnd = () => {
        isDown = false;
        if (raf) {
          window.cancelAnimationFrame(raf);
          raf = 0;
        }
        pendingScrollLeft = null;
        // Restore snapping after the gesture completes.
        // Use a micro-delay so the last scrollLeft lands before snap engages.
        window.setTimeout(() => {
          if (!widget.classList.contains('mp-jdgm-mobile')) return;
          wrapper.style.scrollSnapType = prevSnapType;
        }, 0);
      };

      // Must be non-passive so we can prevent the browser's native scroll from
      // "starting" before our manual scrollLeft drag kicks in (prevents a jump).
      wrapper.addEventListener('touchstart', onTouchStart, { passive: false, capture: true });
      wrapper.addEventListener('touchmove', onTouchMove, { passive: false, capture: true });
      wrapper.addEventListener('touchend', onTouchEnd, { passive: true, capture: true });
      wrapper.addEventListener('touchcancel', onTouchEnd, { passive: true, capture: true });
    };

    const sync = () => {
      if (mql.matches) {
        widget.classList.add('mp-jdgm-mobile');
        progressTrack.style.display = '';
        container.style.transform = 'none';
        bindTouchDrag();
      } else {
        widget.classList.remove('mp-jdgm-mobile');
        progressTrack.style.display = 'none';
        container.style.removeProperty('transform');
      }
      updateProgress();
    };

    // Judge.me re-applies translateX via autoplay/animation; keep neutralizing while in mobile mode.
    const styleObserver = new MutationObserver(() => {
      if (widget.classList.contains('mp-jdgm-mobile') && container.style.transform !== 'none') {
        container.style.transform = 'none';
      }
    });
    styleObserver.observe(container, { attributes: true, attributeFilter: ['style'] });

    wrapper.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);

    if (typeof mql.addEventListener === 'function') mql.addEventListener('change', sync);
    else if (typeof mql.addListener === 'function') mql.addListener(sync);

    sync();
  };

  const initAll = (root = document) => {
    if (!root.querySelectorAll) return;
    root.querySelectorAll('.jdgm-cards-carousel').forEach(enhanceWidget);
  };

  const boot = () => initAll(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  // Judge.me mounts the widget asynchronously after their script loads.
  const docObserver = new MutationObserver((mutations) => {
    for (const mut of mutations) {
      for (const node of mut.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches?.('.jdgm-cards-carousel')) enhanceWidget(node);
        else if (node.querySelector?.('.jdgm-cards-carousel')) initAll(node);
      }
    }
  });
  docObserver.observe(document.documentElement, { childList: true, subtree: true });
})();

// PDP: mobile sticky bar (variants + ATC) after scrolling past purchase row
(() => {
  const MOBILE_MQ = '(max-width: 989px)';

  const suffixCloneIds = (root, suffix) => {
    root.querySelectorAll('[id]').forEach((el) => {
      el.id = `${el.id}${suffix}`;
    });
    root.querySelectorAll('label[for]').forEach((el) => {
      const ref = el.getAttribute('for');
      if (ref) el.setAttribute('for', `${ref}${suffix}`);
    });
    root.querySelectorAll('input').forEach((input) => {
      input.removeAttribute('form');
    });
  };

  const initStickyBar = (stickyBar) => {
    if (stickyBar.dataset.mpStickyBound === '1') return;

    const sectionId = stickyBar.dataset.sectionId;
    const anchor = document.querySelector('[data-mp-pdp-purchase-anchor]');
    const mainPicker = document.querySelector(`variant-selects[data-section="${sectionId}"]`);
    const variantsMount = stickyBar.querySelector('[data-mp-sticky-variants]');
    const submitBtn = stickyBar.querySelector('[data-mp-sticky-submit]');
    if (!anchor || !mainPicker || !variantsMount || !submitBtn) return;

    stickyBar.dataset.mpStickyBound = '1';

    let syncing = false;

    const getMainSubmit = () => document.getElementById(`ProductSubmitButton-${sectionId}`);

    const updateStickySubmit = () => {
      const mainBtn = getMainSubmit();
      const textWrap = stickyBar.querySelector('[data-mp-sticky-submit-text]');
      if (!mainBtn || !textWrap) return;

      submitBtn.disabled = mainBtn.disabled;
      submitBtn.classList.toggle('disabled', mainBtn.disabled);

      if (mainBtn.disabled) {
        textWrap.textContent = mainBtn.querySelector('span')?.textContent?.trim() || '';
        return;
      }

      const addLabel = window.variantStrings?.addToCart || 'Dodaj do koszyka';
      const priceText = document.querySelector(`#price-${sectionId} .price-item--last`)?.textContent?.trim() || '';
      textWrap.textContent = priceText ? `${addLabel} • ${priceText}` : addLabel;
    };

    const syncPickerToSticky = () => {
      if (!variantsMount) return;
      mainPicker.querySelectorAll('fieldset.product-form__input').forEach((fieldset, index) => {
        const stickyFieldset = variantsMount.children[index];
        if (!stickyFieldset) return;
        const checked = fieldset.querySelector('input[type="radio"]:checked');
        if (!checked) return;
        const stickyInput = stickyFieldset.querySelector(
          `input[type="radio"][name="${CSS.escape(checked.name)}"][value="${CSS.escape(checked.value)}"]`
        );
        if (stickyInput) stickyInput.checked = true;

        fieldset.querySelectorAll('input[type="radio"]').forEach((mainInput) => {
          const stickyLabel = stickyFieldset.querySelector(`label[for="${mainInput.id}-sticky"]`);
          if (!stickyLabel) return;
          const mainLabel = fieldset.querySelector(`label[for="${mainInput.id}"]`);
          stickyLabel.classList.toggle('disabled', mainLabel?.classList.contains('disabled') ?? false);
        });
      });
    };

    const syncStickyToMain = (event) => {
      if (syncing) return;
      const input = event.target;
      if (!input || input.type !== 'radio') return;

      const mainInput = mainPicker.querySelector(
        `input[type="radio"][name="${CSS.escape(input.name)}"][value="${CSS.escape(input.value)}"]`
      );
      if (!mainInput || mainInput.checked) return;

      syncing = true;
      mainInput.checked = true;
      mainInput.dispatchEvent(new Event('change', { bubbles: true }));
      syncing = false;
    };

    const rebuildStickyVariants = () => {
      variantsMount.innerHTML = '';
      mainPicker.querySelectorAll('fieldset.product-form__input').forEach((fieldset) => {
        const clone = fieldset.cloneNode(true);
        suffixCloneIds(clone, '-sticky');
        variantsMount.appendChild(clone);
      });
      variantsMount.querySelectorAll('input[type="radio"]').forEach((input) => {
        input.addEventListener('change', syncStickyToMain);
      });
      syncPickerToSticky();
    };

    rebuildStickyVariants();

    mainPicker.addEventListener('change', () => {
      if (syncing) return;
      syncing = true;
      syncPickerToSticky();
      syncing = false;
      updateStickySubmit();
    });

    submitBtn.addEventListener('click', () => {
      const mainBtn = getMainSubmit();
      if (mainBtn && !mainBtn.disabled) mainBtn.click();
    });

    const mq = window.matchMedia(MOBILE_MQ);
    const setVisible = (visible) => {
      stickyBar.classList.toggle('is-visible', visible);
      stickyBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      document.body.classList.toggle('mp-pdp-sticky-active', visible && mq.matches);
    };

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!mq.matches) {
          setVisible(false);
          return;
        }
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        setVisible(show);
      },
      { threshold: 0, rootMargin: '0px' }
    );

    observer.observe(anchor);

    const onMqChange = () => {
      if (!mq.matches) {
        setVisible(false);
        return;
      }
      updateStickySubmit();
      rebuildStickyVariants();
    };

    mq.addEventListener('change', onMqChange);

    updateStickySubmit();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (!event?.data || event.data.sectionId !== sectionId) return;
        window.requestAnimationFrame(() => {
          syncPickerToSticky();
          updateStickySubmit();
        });
      });
    }
  };

  const boot = (root = document) => {
    root.querySelectorAll('[data-mp-pdp-sticky-bar]').forEach(initStickyBar);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(document), { once: true });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target) boot(event.target);
  });
})();

